var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsGuestEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66666 5.83301L8.47076 10.5959C9.02173 10.9816 9.29722 11.1744 9.59688 11.2491C9.86157 11.3151 10.1384 11.3151 10.4031 11.2491C10.7028 11.1744 10.9782 10.9816 11.5292 10.5959L18.3333 5.83301M5.66666 16.6663H14.3333C15.7335 16.6663 16.4335 16.6663 16.9683 16.3939C17.4387 16.1542 17.8212 15.7717 18.0608 15.3013C18.3333 14.7665 18.3333 14.0665 18.3333 12.6663V7.33301C18.3333 5.93288 18.3333 5.23281 18.0608 4.69803C17.8212 4.22763 17.4387 3.84517 16.9683 3.60549C16.4335 3.33301 15.7335 3.33301 14.3333 3.33301H5.66666C4.26653 3.33301 3.56646 3.33301 3.03168 3.60549C2.56128 3.84517 2.17882 4.22763 1.93914 4.69803C1.66666 5.23281 1.66666 5.93288 1.66666 7.33301V12.6663C1.66666 14.0665 1.66666 14.7665 1.93914 15.3013C2.17882 15.7717 2.56128 16.1542 3.03168 16.3939C3.56646 16.6663 4.26653 16.6663 5.66666 16.6663Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsGuestEmail);
export default __webpack_public_path__ + "static/media/as-guest-email.9b45817bbf3802890f16ede681c86362.svg";
export { ForwardRef as ReactComponent };